module.exports = __webpack_public_path__ + "img/transplant_certificate.d7cffd46.png";